<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('routes.Delivery') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent  :ClickFun="navigateToNewBrand" svg="2"
                    :Title="$t('Delivery.create')" />
            </div>
        </div>
        <v-card elevation="0">
            <DeliveriesList v-if="!isDelivery()" :showFilterDialog="showFilterDialog" @open-filter-dialog="openFilterDialog"/>
        </v-card>
    </div>
</template>
<script>
import { isClient, isDelivery } from "@/api/index";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import DeliveriesList from "./DeliveriesList.vue";
export default {
    components: {
        genericBtnComponent,
        DeliveriesList,
    },
    data() {
        return {
            showFilterDialog : false
        }
    },
    beforeCreate() {
        if (isDelivery()){
            this.$router.push({ name: 'MyDeliveryCompany' });
        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.purchasesOrder');
    },
    methods: {
        isDelivery(){
            return isDelivery();
        },
        openFilterDialog(newValue){
            this.showFilterDialog = newValue;
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
        navigateToNewBrand() {
            this.$router.push({ path: '/NewDelivery' });
        },
        isClient() {
            return isClient()
        }
    }
};

</script>
